module.exports = __webpack_public_path__ + "img/art-work-icon14.27e92c86.png";